@if (!loaded) {
  <se-fe-spinner
    [seFeDataSize]="900"
    [seFeDataCenter]="true">
  </se-fe-spinner>
}
@if (loaded) {
  <se-fe-list>
    @for (listItem of listItems; track listItem) {
      <se-fe-list-item>
        <se-fe-header [seFeDataSubtitle]="listItem.subtitle" [seFeDataSize]="600">
          <div seFeHeaderTitle class="membership-list-title">
            <a seFeLink="low" [href]="listItem.url">
              {{ listItem.title }}
            </a>
          </div>
          <div seFeHeaderTitleExtra>
            <se-fe-chip [seFeDataText]="listItem.chip.title" [seFeDataStyle]="listItem.chip.color" seFeDataIconLeft="dot_fill"></se-fe-chip>
          </div>
          <div seFeHeaderActions>
            <se-fe-icon-button
              [seFeMenuTrigger]="listItemMenu"
              seFeDataEmphasis="low">
              <se-fe-icon seFeDataName="more" seFeDataSize="700"></se-fe-icon>
            </se-fe-icon-button>
            <se-fe-menu #listItemMenu [seFeDataOptions]="listItem.menuOptions"></se-fe-menu>
          </div>
        </se-fe-header>
      </se-fe-list-item>
    }
  </se-fe-list>
}
@if (loaded && !listItems.length) {
  <se-fe-empty-state seFeDataTitle="No Memberships Found">
    <se-fe-icon seFeEmptyStateIcon seFeDataName="spot_whistle" seFeDataSize="950"></se-fe-icon>
  </se-fe-empty-state>
}
